/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Divider, Tabs, Tab, Typography, useTheme } from '@mui/material';
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ResponsibleForm, ToolsDetails } from '../../components/custom';
import { ConfirmationDialog } from '../../components/shared';
import { CustomAlert } from '../../components/shared/VAlert';
import { LayoutBase } from '../../layouts';
import { ICompany, CompanyServices } from '../../services/api/company/CompanyServices';
import React from 'react';
import { CompanyForm } from '../../components/custom';
import { helpers } from '../../services/helpers/helpers';
import { IUser } from '../../services/api/users/UserServices';


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    tabValue: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, tabValue, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={tabValue !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {tabValue === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const EditCompany = () => {

    const { id } = useParams();
    const navigate = useNavigate(); 
    const [dialogOpen, setDialogOpen] = useState(false);
    const [value, setValue] = React.useState(0);
    const theme = useTheme();
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });
    const [data, setData] = useState<ICompany>({
        bairro: '',
        cep: '',
        cidade: '',
        company_name: '',
        company_register: '',
        complemento: '',
        email: '',
        estado: '',
        logo: '',
        nome: '',
        numero: '',
        pais: '',
        phone: '',
        rua: '',
        site: '',
        slug: '',
        quantidade_barragens: 0,
    });

    const [userData, setUserData] = useState<IUser>();


    const handleTabChange = (e: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleTabValue = (newValue: number) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (id !== 'novo' && id) {
            fetchData(id);
        }
    }, []);

    function fetchData(uuid: string) {
        CompanyServices.getById(uuid)
            .then((response) => {
                if (response instanceof Error) {
                    console.log('Erro ao buscar dados', response.message);
                } else {
                    setData(response);
                }
            });
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const updatedData = { ...data, [name]: value };
        setData(updatedData);
    };

    const fetchAdress = () => {
        if (data && data.cep?.length === 9) {
            const formattedCep = data.cep.replace('.', '');
            helpers.getAdress(formattedCep)
                .then((response) => {
                    if (response instanceof Error) {
                        console.log(response.message);
                    } else {
                        setData(prevData => ({
                            ...prevData,
                            rua: response.logradouro,
                            bairro: response.bairro,
                            cidade: response.localidade,
                            estado: response.uf,
                        }));
                    }
                });
        }
    };

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target;
        setData(prevData => ({
            ...prevData,
            [name]: checked
        }));
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const selectedFile = e.target.files[0];
            setData(prevData => ({
                ...prevData,
                image: selectedFile
            }));
        }
    };

    const handleConfirmDelete = async () => {
        if (id !== 'novo' && id !== undefined) {
            const response = await CompanyServices.delet(id);
            if (response instanceof Error) {
                setAlertInfo({ open: true, message: 'Não foi possível apagar a empresa!', severity: 'error' });
                setTimeout(() => {
                    navigate('/companies');
                }, 2000);
            }
            setAlertInfo({ open: true, message: 'Empresa excluída!', severity: 'success' });
            setTimeout(() => {
                navigate('/companies');
            }, 2000);
        }
        setDialogOpen(false);
    };

    const handleClean = () => {
        setData({
            bairro: '',
            cep: '',
            cidade: '',
            company_name: '',
            company_register: '',
            complemento: '',
            email: '',
            estado: '',
            logo: '',
            nome: '',
            numero: '',
            pais: '',
            phone: '',
            rua: '',
            site: '',
            slug: '',
            quantidade_barragens: 0,
        });
    };

    function handleNew() {
        navigate('/companies/company_registration/novo');
        window.location.reload();
    }

    const showAlert = (message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
        setAlertInfo({ open: false, message: '', severity: 'info' });
        setTimeout(() => {
            setAlertInfo({ open: true, message, severity });
        }, 100);
    };

    const handleAlertChange = (message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
        showAlert(message, severity);
    };

    function handleDeleteClick() {
        setDialogOpen(true);
    }

    const hanldeSaveCompany = (newValue: ICompany) => {
        setData(newValue);
    };

    return (
        <LayoutBase
            title={'Cadastro de Empresa'}
            tollBar={
                <ToolsDetails
                    onClickDelet={() => handleDeleteClick()}
                    onClickNew={() => handleNew()}
                    showSaveButton={false}
                />
            }
        >
            <Box width={'100%'}>
                <Box>
                    <Tabs centered={true} onChange={handleTabChange} value={value}>
                        <Tab label={<Typography color={theme.palette.primary.main} variant='body2'>Empresa</Typography>} {...a11yProps(0)} />
                        <Tab label={<Typography color={theme.palette.primary.main} variant='body2'>Responsavel</Typography>} {...a11yProps(1)} />
                    </Tabs>
                    <Divider />
                </Box>

                <CustomTabPanel tabValue={value} index={0}>
                    <CompanyForm data={data} fetchAdress={fetchAdress} handleChange={handleChange} handleFileChange={handleFileChange} handleSwitchChange={handleSwitchChange}
                        showAlert={handleAlertChange} handleTabChange={handleTabValue} setResponse={hanldeSaveCompany} handleClean={handleClean} />
                </CustomTabPanel>

                <CustomTabPanel tabValue={value} index={1}>
                    {/* Alteração aqui: Passando a função navigate como prop */}
                    <ResponsibleForm initialData={data} showAlert={handleAlertChange} navigateToCompanies={() => navigate('/companies')} />
                </CustomTabPanel>

            </Box>
            <ConfirmationDialog
                isOpen={dialogOpen}
                onClose={() => setDialogOpen(false)}
                onConfirm={handleConfirmDelete}
                title="Confirmar Exclusão"
                message="Tem certeza de que deseja excluir esta empresa?"
            />
            {alertInfo.open &&
                <CustomAlert
                    severity={alertInfo.severity}
                    message={alertInfo.message}
                />
            }
        </LayoutBase>
    );
};